import React, {Component} from 'react'
import propTypes from 'prop-types'
import {get, isEmpty} from 'lodash'
import TextField from '@material-ui/core/TextField'
import BaseEditor from './baseEditor'
import Button from '../../../components/button'
import {prefix} from 'helpers/component'
import {t} from "helpers/language"
import generateUUID from '../../../helpers/uuid'

require('./inlineEditor.scss')
const getClassName = prefix('inlineEditor-stringEditor-')

class StringEditor extends Component {
  state = {
    value: this.props.value,
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.open && nextProps.open) {
      this.setState({value: nextProps.value})
    }
  }

  onFocus = () => {
    document.execCommand('selectAll')
  }

  change = (e) => {
    this.setState({value: e.target.value})
  }

  commit = () => {
    this.props.onCommit(this.state.value.trim())
  }

  cancel = () => {
    this.props.onCancel()
  }

  keyDown = (e) => {
    switch (e.keyCode) {
      case 13:  // ENTER
        if ((this.props.rows || 1) <= 1) this.commit()
        break
      case 27:  // ESC
        this.cancel()
        break
    }
  }

  render() {
    const {
      open,
      anchor,
      label,
      width,
      multiLine,
      rows,
      options,
      commitButtonsInline,
      commitLabel,
      cancelLabel,
      commitButtonWidth,
      cancelButtonWidth,
      isCheckEmptyStringEnabled,
      ...otherProps
    } = this.props
    const {value} = this.state

    let height = 48
    let editorWidth = width

    if (multiLine) {
      height += (24 * (rows - 1))
    }
    if (!commitButtonsInline) {
      height += 48
    } else {
      editorWidth += commitButtonWidth
      editorWidth += cancelButtonWidth
      editorWidth += 12
    }

    const buttonsClass = commitButtonsInline ? 'buttons-inline' : 'buttons'
    const maxLength = get(options, 'length')
    const isCommitDisabled = isCheckEmptyStringEnabled && isEmpty(value)

    return (
      <BaseEditor
        open={open}
        anchor={anchor}
        {...otherProps}
        height={height}
        width={editorWidth}
        onClose={this.cancel}
        onFocus={() => {
        }}
      >
        <TextField
          className={getClassName('text-field')}
          placeholder={label}
          value={value || ''}
          inputRef={e => {
            this.input = e
          }}
          onChange={this.change}
          onKeyDown={this.keyDown}
          style={{width}}
          multiline={multiLine}
          rows={rows}
          rowsMax={rows}
          id={generateUUID()}
          autoFocus={true}
          inputProps={{maxLength}}
          onFocus={this.onFocus}
        />
        <div className={getClassName(buttonsClass)}>
          <Button
            className={getClassName('cancel-button')}
            label={cancelLabel}
            flat={true}
            width={cancelButtonWidth}
            onClick={this.cancel}
          />
          <Button
            className={getClassName('commit-button')}
            disabled={isCommitDisabled}
            label={commitLabel}
            primary={true}
            width={commitButtonWidth}
            onClick={this.commit}
          />
        </div>
      </BaseEditor>
    )
  }
}

StringEditor.propTypes = {
  value: propTypes.string,
  open: propTypes.bool.isRequired,
  anchor: propTypes.object,
  label: propTypes.oneOfType([
    propTypes.string,
    propTypes.object,
  ]),
  width: propTypes.number,
  multiLine: propTypes.bool,
  rows: propTypes.number,
  options: propTypes.shape({
    length: propTypes.number,
  }),
  isCheckEmptyStringEnabled: propTypes.bool,
  commitButtonsInline: propTypes.bool,
  commitLabel: propTypes.oneOfType([
    propTypes.string,
    propTypes.object,
  ]),
  cancelLabel: propTypes.string,
  commitButtonWidth: propTypes.number,
  cancelButtonWidth: propTypes.number,
  onCommit: propTypes.func.isRequired,
  onCancel: propTypes.func.isRequired,
}

StringEditor.defaultProps = {
  width: 300,
  rows: 1,
  isCheckEmptyStringEnabled: false,
  commitButtonsInline: true,
  commitLabel: t('Update'),
  cancelLabel: 'Cancel',
  commitButtonWidth: 90,
  cancelButtonWidth: 90,
}

export default StringEditor
